export default "__VITE_ASSET__BbVbShgl__"